var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.011,
    height: 26,
    viewBox: "0 0 30.011 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Archive_Icon",
    transform: "translate(2158 94.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11150",
    "data-name": "Group 11150",
    transform: "translate(-2150.087 -87.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36396",
    "data-name": "Path 36396",
    d: "M7.913.63H0V-.5H7.913Z",
    transform: "translate(3.391 7.283)",
    fill: "#91b6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_885",
    "data-name": "Ellipse 885",
    d: "M7.348,1A6.348,6.348,0,1,0,13.7,7.348,6.355,6.355,0,0,0,7.348,1m0-1A7.348,7.348,0,1,1,0,7.348,7.348,7.348,0,0,1,7.348,0Z",
    fill: "#91b6bb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "np_folder_1594035_000000",
    d: "M16.472,18.5h5.616a2.988,2.988,0,0,1,2.378,1.188l.963,1.286a1.852,1.852,0,0,0,1.473.736H40.539a2.975,2.975,0,0,1,2.972,2.972V41.528A2.975,2.975,0,0,1,40.539,44.5H16.472A2.975,2.975,0,0,1,13.5,41.528V21.472A2.975,2.975,0,0,1,16.472,18.5Zm24.067,24.87a1.844,1.844,0,0,0,1.842-1.841V24.681a1.844,1.844,0,0,0-1.842-1.842H26.9a2.988,2.988,0,0,1-2.378-1.188l-.963-1.286a1.852,1.852,0,0,0-1.473-.736H16.472a1.844,1.844,0,0,0-1.842,1.842V41.528a1.844,1.844,0,0,0,1.842,1.841Z",
    transform: "translate(-2171.5 -113)",
    fill: "#91b6bb"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/Archive_Icon.981cf239.svg";
export { ForwardRef as ReactComponent };